import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "react-day-picker/dist/style.css"; // Required for DayPicker
import "driver.js/dist/driver.css"; // Required for Driver.js
import { Toaster } from "sonner";
import { GlobalEventProvider } from "./application/hooks/events";
import { PwaUpdateNotification } from "./interface/components/pwa/update-notification";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // Do not refetch on window focus
      retry: 1, // Retry failed requests maximum 1 times
      staleTime: 1000 * 60 * 5, // 5 minutes (will cache data for 5 minutes unless is invalidated)
    },
  },
});

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <>
      <Toaster richColors />
      {/* PWA update banner — shown when a new version has been deployed */}
      <PwaUpdateNotification />
      <QueryClientProvider client={queryClient}>
        {/* INFO: Provide global event handling (depends on QueryClient for some events */}
        <GlobalEventProvider />
        {children}
      </QueryClientProvider>
    </>
  );
}

declare global {
  interface Window {
    __TANSTACK_QUERY_CLIENT__: QueryClient;
  }
}
window.__TANSTACK_QUERY_CLIENT__ = queryClient;
